// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import extend from 'lodash/extend';

export default function(state = {}, action) {
  const typeMap = {
    RECIRC_FEED_LOADING() {
      return {
        hide: false,
        isLoading: true,
        recircFeed: action.recircFeed
      };
    },
    RECIRC_FEED_LOADED() {
      return {
        hide: false,
        isLoading: false,
        data: action.recircFeed
      };
    },
    RECIRC_FEED_ERROR() {
      return {
        hide: false,
        isLoading: false,
        error: true,
        errorMessage: action.recircFeed.errorMessage
      };
    },
    HIDE_RECIRC_FEED() {
      return extend({}, state, {
        hide: true
      });
    }
  };

  if (/PAGE_LOADED/.test(action.type)) {
    return extend({}, state, {
      hide: false
    });
  }

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
